import { responseReducers } from "./reducerHelpers/dispatchProps"

export const _secretDataName = 'secret'

const rts = {
  handleLoad_itemData: 'handleLoad_itemData',
  handleSecretData: 'handleSecretData',
  handleSetFetchData: 'handleSetFetchData',
  handleSetAlphabetValue: 'handleSetAlphabetValue',
  handleUpdateData: 'handleUpdateData',
}

const getSecretData = async (dr, propSectionKey) => {
  const ref = dr.collection(propSectionKey).doc(_secretDataName)
  const res = await ref.get()
  return res
}

export const dataReducer = (state, action) => {

  const { dispatch, dataValue, type, dataResultProps } = action
  const { name } = dataResultProps ?? {}

  const { handleUpdateData } = dataHandlers(dispatch)

  switch (type) {

    case rts.handleLoad_itemData:
      const { itemDataInfo } = action
      const { itemData: itemData_info, itemDataName, itemDataCollectionName } = itemDataInfo ?? {}
      return {
        ...state,
        fetched: true,
        isLoading: false,
        uivi: itemDataName,
        [itemDataName]: itemData_info,
        [itemDataCollectionName]: itemData_info,
        viewListData: itemData_info,
        viewListDataCount: itemData_info ? Object.keys(itemData_info).length : 0,
      }

    case rts.handleSecretData:

      const { dataRef: dr, dataName } = state
      const { secretProps } = action
      const { propSectionKey, itemData } = secretProps ?? {}
      const { key: itemKey } = itemData ?? {}

      getSecretData(dr, propSectionKey).then(res => {
        const secretItemData = res.data()
        const existingItemData = state[dataName][itemKey]
        const combinedItemData = { ...existingItemData, ...secretItemData }
        handleUpdateData(combinedItemData)
      })

      return { ...state }

    case rts.handleUpdateData:
      const { updateData } = action
      const _vld = { ...state.viewListData }
      _vld[updateData.key] = updateData
      return {
        ...state,
        [state.dataName]: action.updateData,
        viewListData: _vld,
        viewListDataCount: _vld ? Object.keys(_vld).length : 0,
        time_stamp: Date.now()
      }

    case rts.handleSetAlphabetValue:
      return {
        ...state,
        alphabetValue: action.alphabetValue
      }

    case rts.handleSetFetchData:
      return {
        ...state,
        fetchData: action.fetchData
      }


    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { [name]: dataValue, fetched: true })

    default:
      return { ...state }
  }
}

export const dataInitialState = (initState) => {
  const { diKey, isCombinedData, isSettingData, itemListData, uivi, updateProps, viewItem, pageImages } = initState ?? {}
  return {
    combinedListData: {},
    confirmation: null,
    diKey,
    isCombinedData,
    isSettingData,
    itemListData,
    pageImages,
    singleDataItem: false,
    singles: {},
    uivi,
    updateProps,
    viewItem,
  }
};

export const dataHandlers = (dispatch) => {
  return {
    handleLoad_itemData: (itemDataInfo) => { dispatch({ type: rts.handleLoad_itemData, itemDataInfo }) },
    handleSecretData: (secretProps) => { dispatch({ type: rts.handleSecretData, dispatch, secretProps }) },
    handleSetAlphabetValue: (alphabetValue) => { dispatch({ type: rts.handleSetAlphabetValue, alphabetValue }) },
    handleSetFetchData: (fetchData) => { dispatch({ type: rts.handleSetFetchData, fetchData }) },
    handleUpdateData: (updateData) => { dispatch({ type: rts.handleUpdateData, updateData }) },
  }
}